// Survives the logout/login cycle (unlike Redux state, which is wiped by `store/reset`) so a page
// that forces re-auth can send the user straight back to where they were once they log back in.
const POST_LOGIN_REDIRECT_STORAGE_KEY = 'pendingPostLoginRedirectPath';

export function setPendingPostLoginRedirect(path: string): void {
  localStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, path);
}

// Consumes (reads + clears) the stored path so it's only ever applied to the next login.
export function consumePendingPostLoginRedirect(): string | null {
  const path = localStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
  if (path) {
    localStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
  }
  return path;
}
